<h2 mat-dialog-title>
    {{ 'polls_settings.reminder_dialog.title' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10">
    @if(poll){
        <em>    {{ 'polls_settings.reminder_dialog.desc1' | translate}}</em>
        <p>
            {{ 'polls_settings.reminder_dialog.desc2' | translate}}
            @for(team of poll.teams; track $index){
                <span class="badge text-bg-light me-1">{{team}}</span>
            }
            ?
        </p>        
    }
</mat-dialog-content>

<mat-dialog-actions class="justify-content-end">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'No' | translate}}</button>
    <button type="submit"
            class="btn btn-primary" 
            (click)="sendReminder()">{{'Yes' | translate}}</button>
</mat-dialog-actions>